import React, { ReactNode } from "react";
import Slider, { Settings } from "react-slick";
import CategoriaModel from "../model/CategoriaModel";
import NavegadorUtil from "../util/NavegadorUtil";
import { Link } from "react-router-dom";

const settings: Settings = {
  speed: 300,
  infinite: false,
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        dots: false,
        slidesToShow: 3.5,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        touchMove: false,
        dots: true,
        arrows: true,
        slidesToShow: 4.5,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1300,
      settings: {
        touchMove: false,
        dots: true,
        arrows: true,
        slidesToShow: 5.5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 3000,
      settings: {
        touchMove: false,
        dots: true,
        arrows: true,
        slidesToShow: 6.5,
        slidesToScroll: 5,
      },
    },
  ],
};

type CategoriasHomeProps = {
  items: CategoriaModel[];
  imagens: CategoriaModel[];
  children?: ReactNode;
};

class CategoriasHome extends React.Component<CategoriasHomeProps, any> {
  render(): any {
    const { items, imagens } = this.props;
    return (
      <Slider {...settings} className="categories">
        {items.map((categoria: CategoriaModel) => {
          if (categoria.ativo) {
            const categoriaImagem: CategoriaModel | undefined = imagens.find(i => i.yourId === categoria.yourId);

            if (categoriaImagem) {
              categoria.imagem = categoriaImagem.imagem;
            }

            const categoriaUrl: string = NavegadorUtil.getUrl(
              `/categoria?catId=${categoria.categoriaId}&nome=${categoria.nome}`
            );

            return (
              <div className="item" key={categoria.categoriaId}>
                <Link to={categoriaUrl}>
                  <div 
                    className="ico" 
                    style={{backgroundImage: `url(`+(!categoria.imagem ? "" : categoria.imagem)+`)`}}
                    title={categoria.nome}
                  ></div>
                  <p>{categoria.nome}</p>
                </Link>
              </div>
            );
          }
          return "";
        })}
      </Slider>
    );
  }
}

export default CategoriasHome;
